import { AlertDialog, NumberedList } from "client/Components";
import { PropsWithChildren, ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";

export type SharePointFeedInformationDialogProps = {
	onClose(): void;
};

export const SharePointFeedInformationDialog = (props: PropsWithChildren<SharePointFeedInformationDialogProps>): ReactElement => {
	const {
		onClose
	} = props;

	return (
		<AlertDialog
			title={localize("_HowDoIFindTheRSSFeedUrlForASharePointList")}
			onClose={onClose}
			showCloseButton
			trackingId="share-point-feed-information-dialog"
		>
			<p>{localize("_YouCanAddNewsAnnouncementsDocumentsAndMoreFromYourSharePointSitesViaTheFollowingSteps")}</p>
			<NumberedList trackingId="steps">
				<NumberedList.Item>{localize("_GoToYourSharePointSite")}</NumberedList.Item>
				<NumberedList.Item>{localize("_GoToTheList")}</NumberedList.Item>
				<NumberedList.Item>{localize("_OnTheListsCommandBarClickTheAllItemsDocumentsDropDownMenuAndThenSelectEditCurrentView")}</NumberedList.Item>
				<NumberedList.Item>{localize("_ClickTheRSSIconOnTheRightOfTheViewsWebAddress")}</NumberedList.Item>
				<NumberedList.Item>{localize("_CopyTheUrlFromTheAddressBar")}</NumberedList.Item>
			</NumberedList>
		</AlertDialog>
	);
};

SharePointFeedInformationDialog.displayName = "SharePointFeedInformationDialog";